import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import customizationReducer from './customizationReducer';
import snackbarReducer from './snackbarReducer';
import accountReducer from './accountReducer';

// ===========================|| COMBINE REDUCER ||=========================== //

const reducer = combineReducers({
    customization: persistReducer(
        {
            key: 'customization',
            storage,
            keyPrefix: 'pagomundo-',
            whitelist: ['locale']
        },
        customizationReducer
    ),
    snackbar: snackbarReducer,
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'pagomundo-',
            blacklist: ['isProfileActiveError']
        },
        accountReducer
    )
});

export default reducer;
